import React from 'react'

import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'
import Image from '../../../../../components/pdf/Image'
import Grid, { Col } from '../../../../../components/pdf/Grid'

const Footer = () => {
  return (
    <>
      <Separator weight={20} />
      <Grid justify="center" align="center" direction="column">
        <Col width="100%">
          <Text>
            This Rough Order of Magnitude estimate is being provided for budgetary and planning purposes only. It is
            non-binding and is not considered a contractable offer for sale of Axon goods or services.
          </Text>
        </Col>
        <Separator weight={10} />
        <Col width="100%">
          <Text>
            Tax is estimated based on rates applicable at date of quote and subject to change at time of invoicing. If a
            tax exemption certificate should be applied, please submit prior to invoicing.
          </Text>
        </Col>
        <Separator weight={10} />
        <Col>
          <Image src="/pdfs/axon/axon-logo.svg" maxWidth={130} ignoreFixedSize />
        </Col>
      </Grid>
    </>
  )
}

export default Footer
